// import {
//   FETCH_HOTEL_FAILURE,
//   FETCH_HOTEL_REQUEST,
//   FETCH_HOTEL_SUCCESS,
// } from "./hotelActionTypes";

// export const fetchHotelRequest = () => ({
//   type: FETCH_HOTEL_REQUEST,
// });

// export const fetchHotelSuccess = (data, dataType) => ({
//   type: FETCH_HOTEL_SUCCESS,
//   payload: { data, type: dataType },
// });

// export const fetchHotelFailure = (error) => ({
//   type: FETCH_HOTEL_FAILURE,
//   payload: error,
// });
import {
  FETCH_HOTEL_REQUEST,
  FETCH_HOTEL_SUCCESS,
  FETCH_HOTEL_FAILURE,
  CREATE_HOTEL_REQUEST,
  CREATE_HOTEL_SUCCESS,
  CREATE_HOTEL_FAILURE,
  UPDATE_HOTEL_REQUEST,
  UPDATE_HOTEL_SUCCESS,
  UPDATE_HOTEL_FAILURE,
  DELETE_HOTEL_REQUEST,
  DELETE_HOTEL_SUCCESS,
  DELETE_HOTEL_FAILURE,
} from "./hotelActionTypes";

// FETCH
export const fetchHotelRequest = () => ({
  type: FETCH_HOTEL_REQUEST,
});

export const fetchHotelSuccess = (data, dataType) => ({
  type: FETCH_HOTEL_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchHotelFailure = (error) => ({
  type: FETCH_HOTEL_FAILURE,
  payload: error,
});

// CREATE
export const createHotelRequest = () => ({
  type: CREATE_HOTEL_REQUEST,
});

export const createHotelSuccess = (data, dataType) => ({
  type: CREATE_HOTEL_SUCCESS,
  payload: { data, type: dataType },
});

export const createHotelFailure = (error) => ({
  type: CREATE_HOTEL_FAILURE,
  payload: error,
});

// UPDATE
export const updateHotelRequest = () => ({
  type: UPDATE_HOTEL_REQUEST,
});

export const updateHotelSuccess = (data, dataType) => ({
  type: UPDATE_HOTEL_SUCCESS,
  payload: { data, type: dataType },
});

export const updateHotelFailure = (error) => ({
  type: UPDATE_HOTEL_FAILURE,
  payload: error,
});

// DELETE
export const deleteHotelRequest = () => ({
  type: DELETE_HOTEL_REQUEST,
});

export const deleteHotelSuccess = (data, dataType) => ({
  type: DELETE_HOTEL_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteHotelFailure = (error) => ({
  type: DELETE_HOTEL_FAILURE,
  payload: error,
});
